"use client";

import { useEffect } from "react";
import { handleHashOnLoad } from "@/utils/internal/smoothScroll";

/**
 * Component to handle smooth scroll to hash on page load
 */
export function ScrollHandler() {
  useEffect(() => {
    // Handle scroll on initial page load
    handleHashOnLoad(100);
    
    // Handle browser back/forward navigation
    const handlePopState = () => {
      setTimeout(() => handleHashOnLoad(100), 100);
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return null;
}